import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Icon, Modal } from 'semantic-ui-react';
import {
  showDeleteConfirmationModal,
  deleteDiscountRule,
} from 'state/discountRule/actions';

const DeleteDiscountRuleModal = props => {
  const { dispatch, deleteConfirmation } = props;
  const rule = deleteConfirmation.deleteingRule;

  const handleOnCancelButtonClick = () => {
    dispatch(showDeleteConfirmationModal(false, null));
  };

  const handleOnOKButtonClick = () => {
    dispatch(deleteDiscountRule(rule.id));
    dispatch(showDeleteConfirmationModal(false, null));
  };

  const monthsLeft = rule && rule.subscription_period_months_left;
  const monthsDisplay =
    monthsLeft != null && monthsLeft !== -1
      ? `≤ ${monthsLeft} month${monthsLeft === 1 ? '' : 's'} remaining`
      : '-';
  const discountDisplay =
    rule != null ? `${rule.discount_percentage}% discount` : '';

  return (
    <Modal
      open={deleteConfirmation.isOpen}
      onClose={handleOnCancelButtonClick}
      size="small"
    >
      <Modal.Header>
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#fde8e8',
            borderRadius: '50%',
            width: '2em',
            height: '2em',
            marginRight: '0.6em',
            verticalAlign: 'middle',
          }}
        >
          <Icon
            name="warning sign"
            color="red"
            style={{ margin: 0, fontSize: '1em' }}
          />
        </span>
        Delete Renewal Discount
      </Modal.Header>
      <Modal.Content>
        <p style={{ color: '#666', marginBottom: '1em' }}>
          Are you sure you want to delete this renewal discount?
        </p>
        {rule && (
          <div
            style={{
              background: '#f5f5f5',
              borderRadius: '6px',
              padding: '0.9em 1.1em',
              marginBottom: '1em',
            }}
          >
            <p style={{ margin: '0 0 0.3em', fontWeight: 600 }}>
              {monthsDisplay} → {discountDisplay}
            </p>
            <p style={{ margin: 0, color: '#888' }}>
              Applies to: All Subscription Packages
            </p>
          </div>
        )}
        <p style={{ color: '#c0392b', margin: 0 }}>
          This action cannot be undone. Merchants will no longer receive this
          discount.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button basic color="black" onClick={handleOnCancelButtonClick}>
          Cancel
        </Button>
        <Button color="red" onClick={handleOnOKButtonClick}>
          Delete Discount
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = ({ discountRule }) => ({
  deleteConfirmation: discountRule.deleteConfirmation,
});

DeleteDiscountRuleModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  deleteConfirmation: PropTypes.shape({
    isOpen: PropTypes.bool,
    isLoading: PropTypes.bool,
    deleteingRule: PropTypes.object,
  }).isRequired,
};

export default connect(mapStateToProps)(DeleteDiscountRuleModal);
